<template>
  <div class="wash-vial-selector">
    <div class="wash-vial-selector__title">Select vial for washing</div>

    <div class="wash-vial-selector__vials">
      <div
        v-for="vial in WASHING_VIALS"
        :key="vial"
        class="wash-vial-selector__vial-option"
        data-test-id="wash-needle-vial-option"
      >
        <Vial
          checkedVial=""
          :value="String(vial)"
          class="wash-vial-selector__vial"
          data-test-id="btn-wash-needle-vial"
          @model="selectVial"
        />
        <div class="wash-vial-selector__vial-label">{{ vial }}</div>
      </div>
    </div>

    <Btn
      height="s"
      type="primary"
      icon-left="gradient"
      class="wash-vial-selector__all"
      data-test-id="btn-wash-needle-all-vials"
      @click="selectAll"
    >
      Wash in all vials
    </Btn>
  </div>
</template>

<script>
  import Btn from '@/uikitBase/btns/Btn';
  import Vial from '@/uikitProject/vials/shared/Vial';
  import { ALL_WASHING_VIALS_VALUE, EVENT_SELECT, WASHING_VIALS } from '../shared/config.ts';

  export default {
    name: 'WashVialSelector',

    components: {
      Btn,
      Vial,
    },

    data: () => ({
      WASHING_VIALS,
    }),

    methods: {
      selectVial(vial) {
        this.$emit(EVENT_SELECT, Number(vial));
      },

      selectAll() {
        this.$emit(EVENT_SELECT, ALL_WASHING_VIALS_VALUE);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .wash-vial-selector {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    padding: 12px;

    &__title {
      max-width: 150px;
      color: $color-text-default;
      font-weight: $weight-semi-bold;
      line-height: 1.3;
      text-align: center;
    }

    &__vials {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 0;
    }

    &__vial-option {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 28px;
    }

    &__vial {
      flex: 1;
      width: 100%;
      margin: 0;

      &::before {
        content: '';
        display: block;
        padding-top: 100%;
      }
    }

    &__vial-label {
      color: $color-text-second;
      font-size: $size-xs;
      line-height: 1;
    }

    &__all {
      width: fit-content;
    }
  }
</style>
